import * as React from 'react'
import { Stack, Button } from 'react-bootstrap'
import { StyledModal } from '../modal/StyledModal'
import { Action, ActionModalState, ActionTexts, HandleActionModal, InternalInvoiceReport } from './editTypes'
/**
 * A modal component that displays confirmation messages based on different actions.
 * 
 * @param action - The current state of the action modal, determining the type of confirmation.
 * @param addRow - Function to add a new row, optionally with a `groupId`.
 * @param deleteRow - Function to delete a row by its `id`.
 * @param copyRow - Generic function to copy a row, requiring the item and index.
 * @param handleDeleteModal - Function to handle closing or modifying the action modal state.
 * @param invoiceReportOnChange - Function to handle changes to the invoice report (e.g., department changes or comments).
 * @param submit - Function to submit changes.
 * 
 * @returns A modal component displaying the confirmation message and appropriate action buttons.
 */
function ActionModal (action:ActionModalState,addRow:(groupId?:number)=>void,deleteRow:(id:number)=>void,copyRow:<T extends object>(item:T,index:number) => void,handleDeleteModal:HandleActionModal,invoiceReportOnChange:(e:React.ChangeEvent<HTMLTextAreaElement> | number,key:keyof Pick<InternalInvoiceReport,'departmentId' | 'comment'>,item?:InternalInvoiceReport) =>void,submit:(deletedReport?:boolean) => void,reset:(historyId:number)=>void)  {
  // Defines the modal text for each possible action  
  const actionText:ActionTexts[Action] = {
        ADDROW:{title:'Lägg till',body:'Är du säker på att du vill lägga till en ny fakturarad?'},
        ADDARTICLE:{title:'Lägg till artikelrad',body:'Är du säker på att du vill lägga till en artikelrad?'},
        DELETEROW:{title:'Ta bort',body:'Är du säker på att du vill ta bort den valda raden?'},
        DELETEARTICLEROW:{title:'Ta bort artikelrad',body:'Är du säker på att du vill ta bort den valda artikelraden?'},
        COPY:{title:'Kopiera',body:'Är du säker på att du vill koperia den här raden/gruppen?'},
        CHANGEDEPARTMENT:{title:'Ändra/Lägg till avdelning',body:'Är du säker på att du vill ändra/lägga till en ny avdelning på rapporten?'},
        SUBMIT:{title:'Skicka in',body:'Är du säker på att du vill skicka in ändringar?'},
        NONE:{title:'',body:''},
        ERROR:{title:'Fel',body:'Något gick fel, försök igen senare.'},
        DELETEREPORT:{title:'Makulera rapport',body:'Är du säker på att du vill makulera den valda rapporten? All information som är associerad med rapporten, inklusive loggar, fakturarader och kickbackrapport, kommer också att makuleras.'},
        SUBMITBUTDELETEREPORTOPTION:{title:'Skicka in',body:'Är du säker på att du vill skicka in ändringarna? På grund av dessa ändringar kommer inga rader att kvarstå i rapporten, vilket innebär att all associerad information, inklusive loggar, fakturarader och kickbackrapport, kommer att makuleras.'},
        RESET:{title:'Återställ',body:'Rapporten kommer att helt återställas till vald version, är du säker?'}
    }[action.action]
       /**
     * Handles the confirmation action based on the current modal state.
     * Executes the corresponding function when the user confirms an action.
     */
    const handleConfirm = () => {
        switch(action.action) {
            case 'ADDROW':
              addRow();
              break;
            case 'ADDARTICLE':
                addRow(action.index)
                break;  
            case 'COPY':
              if (action.item) {
                copyRow(action.item,action.id)
              } else {
                console.error("No item provided for copy.");
              }
              break;
            case 'DELETEROW':
                deleteRow(action.id)
              break;
            case 'DELETEARTICLEROW':
                deleteRow(action.id)
                break;  
            case 'CHANGEDEPARTMENT':
                  invoiceReportOnChange(action.id,'departmentId')
                  break;
            case 'SUBMIT' :
                submit();
            break;
            case 'DELETEREPORT':
                    submit(true);
                    console.log('TA BORT VALD RAPPORT.');
            break; 
            case 'SUBMITBUTDELETEREPORTOPTION':
                    submit(true);
                    console.log('Hantera ändringar och makulera rapport.'); 
            break;
            case 'RESET':
              reset(action.id);
                console.log('Återställ till version')  
            break;         
            case 'NONE':
              break;
          }
      };
    return(
        <StyledModal 
        onDismiss={() => { handleDeleteModal('NONE',false,-1)}}
        title={<label>{actionText.title}</label>}
        body={
            <div style={{alignContent:'center',flexDirection:'column',textAlign:'center'}}>
            {actionText.body}
          <Stack direction='horizontal' gap={3} style={{justifyContent:"center",marginTop:'15px'}}>
            {action.action !== 'ERROR' &&
            <Button style={{width: 'fit-content'}} className="button button-danger" onClick={() => handleConfirm()}>{actionText.title}</Button>
            }
            <Button style={{width: 100}} className="button button-cancel" onClick={() => handleDeleteModal('NONE',false,-1)}>{'Stäng'}</Button>
          </Stack>
          </div>
        }
      />
    )
}
export {ActionModal}